module.exports = __webpack_public_path__ + "img/cademi.73098844.png";